export const setTempWishListShopAction = (shopId, isWishList) => {
    return {
        type: 'SET_TEMP_WISH_LIST_SHOP',
        isWishList,
        shopId
    }
}